import apiClient from './client';

/**
 * API client for managing API keys
 */

export const listApiKeys = async () => {
  const response = await apiClient.get('/api/api-keys');
  return response.data;
};

export const createApiKey = async (data) => {
  const response = await apiClient.post('/api/api-keys', data);
  return response.data;
};

export const deleteApiKey = async (id) => {
  const response = await apiClient.delete(`/api/api-keys/${id}`);
  return response.data;
};
